import type { Subscriptions } from '@ps/models/lib/creator-subscription';
import {
  PopStoreSubscriptionLevel,
  PopStoreSubscriptionStatus,
} from '@ps/models/lib/creator-subscription';

/**
 * Plan-gate logic for the subscription configuration UI. 1:1 with
 * legacy `canConfigureSubscriptionLevel`.
 *
 *   SUBSCRIBER → always configurable.
 *   FAN        → SUBSCRIBER must already be Active.
 *   VIP        → SUBSCRIBER and FAN must both be Active.
 *
 * The locked tiers still render — but greyed out with a CTA copy
 * change ("Activate the previous tier first"). Driven by this
 * helper inside `SubscriptionTierRow`.
 */
export function canConfigureSubscriptionLevel(
  subscriptions: Subscriptions | null | undefined,
  targetLevel: PopStoreSubscriptionLevel,
): boolean {
  if (!subscriptions) return false;

  const { SUBSCRIBER, FAN, VIP } = PopStoreSubscriptionLevel;

  switch (targetLevel) {
    case SUBSCRIBER:
      return true;

    case FAN:
      return (
        subscriptions[SUBSCRIBER]?.subscription_configuration_status ===
        PopStoreSubscriptionStatus.Active
      );

    case VIP:
      return (
        subscriptions[SUBSCRIBER]?.subscription_configuration_status ===
          PopStoreSubscriptionStatus.Active &&
        subscriptions[FAN]?.subscription_configuration_status ===
          PopStoreSubscriptionStatus.Active
      );

    default:
      return false;
  }
}
